export const INPUT_VALIDATION_STATE_DEFAULT = 'default'
export const INPUT_VALIDATION_STATE_VALID = 'valid'
export const INPUT_VALIDATION_STATE_INVALID = 'invalid'

export type InputValidationState = 'default' | 'valid' | 'invalid'
